import env from "./env";

/** Single source of truth for brand assets, contact details and office data.
 *  Translatable copy (tagline, description, office region names) lives in
 *  the i18n locale files under `common.site.*` instead of here. */
export const site = Object.freeze({
  name: "Mercoris",
  url: env.siteUrl,
  logo: {
    navy: "/assets/logo-navy.png",
    cream: "/assets/logo-cream.png",
    mark: "/assets/mark.png",
  },
  email: "contact@sigvion.com",
  offices: [
    {
      code: "unitedStates",
      phone: "+1 6504279816",
      address: "805 Marbella Vista Way, Leander, TX 78641",
    },
    {
      code: "germany",
      phone: "+49 15129035145",
      address: "Hinterer Rosengarten 24, 97253 Gaukönigshofen",
    },
    {
      code: "india",
      phone: "+91 9381362469",
      address: "#308, DSL ABACUS IT Park, Uppal, Secunderabad, Telangana",
    },
  ],
});

export default site;
